






















import { Component, Prop, Vue } from "vue-property-decorator";
import { DebugHelper } from "@/helper/debugHelper";

import { CloudAccount } from "@/cloudAccount/cloudAccount";

@Component({
  components: {
  }
})

export default class selectSaveStorageModal extends Vue {

    mounted()
    {
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }

    public get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    private localButtonClick(){
        this.$emit('close');
        this.$emit('localSave');
    }

    private cloudButtonClick(){
        this.$store.dispatch("setCloudOperation", this.$router.currentRoute.path);
        this.$store.dispatch("setCloudMode", "save");
        if(this.cloudAccount.isSignIn){
            this.$router.push("/Cloud");
        }
        else{
            this.$store.dispatch("setSignInToGo", "Cloud");
            this.$router.push("/SignIn");
        }
    }
    
    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
